import Styles from './ImagePreview.module.scss'
import { Checkbox } from 'components/Form/Checkbox/Checkbox'
import cx from 'classnames'
import { LoadingShimmerer } from 'components/LoadingShimmerer/LoadingShimmerer'

interface Props {
  url: string
  isSelected: boolean
  alt?: string
  ariaLabel?: string
  showVideoPreview?: boolean
  onSelect?: () => void
  isLoading?: boolean
  isDisabled?: boolean
}

export const ImagePreview = ({ url, isSelected, alt, ariaLabel, onSelect, isLoading, isDisabled }: Props) => {
  return (
    <div
      className={cx(Styles.image, {
        [Styles.isSelected]: isSelected,
        [Styles.isLoading]: isLoading,
        [Styles.isDisabled]: isDisabled,
      })}
      aria-label={ariaLabel}
      onClick={onSelect}
    >
      {isLoading ? <LoadingShimmerer className={Styles.image} borderRadius={10} /> : <img src={url} alt={alt} />}
      {isSelected && (
        <div className={Styles.checkbox}>
          <Checkbox size="lg" isSelected aria-label="Selected image" />
        </div>
      )}
    </div>
  )
}
